import { getAnalyzeImageResult } from "~/api/material"
import { sleep } from "~/common/utils"

const PRODUCT_IMAGE_ANALYSIS_POLL_INTERVAL = 5000
const PRODUCT_IMAGE_ANALYSIS_MAX_ATTEMPTS = 300

export const pollProductImageAnalysis = async (
  taskId: string,
  isStale: () => boolean,
  attempt = 0,
): Promise<API.Material.ProductImageAnalysisResult | undefined> => {
  if (isStale()) return undefined
  if (attempt >= PRODUCT_IMAGE_ANALYSIS_MAX_ATTEMPTS) {
    throw new Error("商品图分析超时，请稍后重试")
  }
  await sleep(PRODUCT_IMAGE_ANALYSIS_POLL_INTERVAL)
  if (isStale()) return undefined
  const response = await getAnalyzeImageResult(
    { task_id: taskId },
    { notify: false },
  )
  if (isStale()) return undefined
  const result = response.data
  if (
    result &&
    (result.name?.trim() ||
      result.category?.trim() ||
      result.target_users?.some((value) => value.trim()) ||
      result.selling_points?.some((value) => value.trim()))
  )
    return result
  return pollProductImageAnalysis(taskId, isStale, attempt + 1)
}
